import { render, staticRenderFns } from "./PatientEditView.vue?vue&type=template&id=3dd5c87c&scoped=true"
import script from "./PatientEditView.vue?vue&type=script&lang=ts"
export * from "./PatientEditView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd5c87c",
  null
  
)

export default component.exports